/* global BX */
/* global ym */
import $ from 'jquery';
import intlTelInput from 'intl-tel-input';
import 'magnific-popup';

window.jQuery = window.$ = $;

window.ajaxFormHandler = function (obForm, link, config = {}) {
	const { type, prefix, doctor } = config;
	const $form = $(obForm);

	let formId = $form.attr('data-id');

	$(document).off('change', 'form[data-id="' + formId + '"] .clinic-ccustom-select');
	$(document).off('change', 'form[data-id="' + formId + '"] .area-ccustom-select:not(.no-select)');
	$(document).off('change', 'form[data-id="' + formId + '"] .area-custom-select');
	$(document).off('submit', 'form[data-id="' + formId + '"]');

	//доп логика для форм consult и answer
	if (type === 'consult') {
		$(document).on('change', 'form[data-id="' + formId + '"] .clinic-ccustom-select', function (e) {
			e.preventDefault();
			e.stopPropagation();

			const $currentForm = $(this).closest('form');
			const selectedOption = this.options[this.selectedIndex];
			const dataId = selectedOption.dataset.id;

			let url = '/_ajax/getDoctors.php?';
			if (prefix === 'en') {
				url = '/en/_ajax/getDoctors.php?';
			}

			fetch(url + 'clinic=' + $(this).val() + '&doctor=' + doctor)
				.then(es => es.text())
				.then(html => {
					// убиваем стилизацию
					$currentForm.find('.area-ccustom-select').styler('destroy');
					// вносим изменения
					$currentForm.find('.area-ccustom-select').html($(html));
					// восстанавливаем стилизацию
					$currentForm.find('.area-ccustom-select').styler({
						selectSmartPositioning: false
					});
					$currentForm.find('.area-ccustom-select').attr('data-clinic', dataId);
				})
				.catch(error => {
					console.error('Ошибка:', error);
				});
		});

		$(document).on('change', 'form[data-id="' + formId + '"] .area-ccustom-select:not(.no-select)', function (e) {
			e.preventDefault();
			e.stopPropagation();

			const $currentForm = $(this).closest('form');
			let clinicId = $currentForm.find('.area-ccustom-select').attr('data-clinic');

			if (typeof clinicId === 'undefined') {
				clinicId = $currentForm.find('.area-ccustom-select').data('clinic');
			}
			let url = '/_ajax/getDoctors.php?';
			if (prefix === 'en') {
				url = '/en/_ajax/getDoctors.php?';
			}

			fetch(url + 'area=' + $(this).val() + '&clinic_id=' + clinicId)
				.then(es => es.text())
				.then(html => {
					// убиваем стилизацию
					$currentForm.find('.doctor-ccustom-select').styler('destroy');
					// вносим изменения
					$currentForm.find('.doctor-ccustom-select').html($(html));
					// восстанавливаем стилизацию
					$currentForm.find('.doctor-ccustom-select').styler({
						selectSmartPositioning: false
					});
				})
				.catch(error => {
					console.error('Ошибка:', error);
				});
		});
	} else if (type === 'answer') {
		$(document).on('change', 'form[data-id="' + formId + '"] .area-custom-select', function (e) {
			e.preventDefault();
			e.stopPropagation();

			const $currentForm = $(this).closest('form');
			let url = '/_ajax/getDoctors.php?';
			if (prefix === 'en') {
				url = '/en/_ajax/getDoctors.php?';
			}

			fetch(url + 'area=' + $(this).val())
				.then(es => es.text())
				.then(html => {
					// убиваем стилизацию
					$currentForm.find('.doctor-custom-select').styler('destroy');
					// вносим изменения
					$currentForm.find('.doctor-custom-select').html($(html));
					// восстанавливаем стилизацию
					$currentForm.find('.doctor-custom-select').styler({
						selectSmartPositioning: false
					});
				})
				.catch(error => {
					console.error('Ошибка:', error);
				});
		});
	}

	$(document).on('submit', 'form[data-id="' + formId + '"]', function (e) {
		BX.PreventDefault(e);
		e.stopPropagation();

		const obForm = this;

		// Очистка ошибок
		obForm.getElementsByClassName('error-msg')[0].innerHTML = '';

		let xhr = new XMLHttpRequest();
		xhr.open('POST', link);

		xhr.onload = function () {
			if (xhr.status != 200) {
				alert(`Ошибка ${xhr.status}: ${xhr.statusText}`);
			} else {
				var json = JSON.parse(xhr.responseText);

				if (!json.success) {
					let errorStr = '';
					for (let fieldKey in json.errors) {
						errorStr += json.errors[fieldKey] + '<br>';
					}

					// Ошибки вывести в элемент с классом error-msg
					obForm.getElementsByClassName('error-msg')[0].innerHTML = errorStr;
					BX.closeWait();
				} else {
					//идентификаторы для яндекс целей
					const currentDir = obForm.dataset.dir;
					switch (type) {
						case "feedback":
							switch (true) {
								case (currentDir === '/'):
									ym(105877761, 'reachGoal', 'index');
									break;
								case (currentDir === '/for-patients/'):
									ym(105877761, 'reachGoal', 'forPatients');
									break;
								case (currentDir === '/how-to-reach/'):
									ym(105877761, 'reachGoal', 'howToReach');
									break;
								case (currentDir === '/prices/'):
									ym(105877761, 'reachGoal', 'priceList');
									break;
								case (currentDir === '/equipment/'):
									ym(105877761, 'reachGoal', 'equipment');
									break;
								case (currentDir.includes('smi') && currentDir !== '/smi/'):
									ym(105877761, 'reachGoal', 'publicationsSlug');
									break;
								case (currentDir.includes('publications') && currentDir !== '/publications/'):
									ym(105877761, 'reachGoal', 'publicationsSlug');
									break;
								case (currentDir.includes('services') && currentDir !== '/services/'):
									ym(105877761, 'reachGoal', 'servicesSlug');
									break;
								case (currentDir.includes('doctors') && currentDir !== '/doctors/'):
									ym(105877761, 'reachGoal', 'olympDoctorsSlug');
									break;
								case (currentDir.includes('brochures') && currentDir !== '/brochures/'):
									ym(105877761, 'reachGoal', 'brochures')
									break;
								case (currentDir.includes('areas') && currentDir !== '/areas/'):
									ym(105877761, 'reachGoal', 'areas');
									break;
							}
							break;
						case ("answer"):
							ym(105877761, 'reachGoal', 'zadat-vopros-doktoru-otpravit');
							break;
					}
					//TODO: костыль для закрытия fancybox, исправить в дальнейшем
					if (type === 'feedback') {
						document.dispatchEvent(new CustomEvent("fancybox.close"));
					}
					$.magnificPopup.open({
						items: {
							src: '#send_modal'
						},
						type: 'inline'
					});
					obForm.reset();
					BX.closeWait();
				}
			}
		};

		xhr.onerror = function () {
			alert("Запрос не удался");
		};

		// grecaptcha.execute('6LddJvwrAAAAAHMg8PiWbsemLBbXn0FVH_nMfzQX', {
		// 	action: 'submit'
		// })
		// 	.then(e => {
		// 		let el = obForm.querySelector('input[name="recaptcha_response"]');
		// 		el.value = e;

		// 		// Передаем все данные из формы
		// 		xhr.send(new FormData(obForm));
		// 	});

		// Передаем все данные из формы
		xhr.send(new FormData(obForm));
	});
}

//При Ajax переининциализируем 
BX.addCustomEvent('onAjaxSuccess', function () {
	setTimeout(function () {
		// Селекты
		const customSelects = $('.js-custom-select').toArray();
		customSelects.forEach(function (select) {
			const $select = $(select);

			if ($select.parent().hasClass('jq-selectbox')) {
				try {
					$select.styler('destroy');
				} catch (e) {
					console.error('Ошибка styler:', e);
				}
			}

			if ($select.attr('required')) {
				$select.addClass('required');
			}

			$select.styler({
				selectSmartPositioning: false
			});
		});

		// Телефоны
		if (typeof intlTelInput !== 'undefined') {
			const phoneInputs = $('.js-phone-input').toArray();

			phoneInputs.forEach(function (input) {
				const $input = $(input);

				if (typeof window.intlTelInputGlobals !== 'undefined' &&
					window.intlTelInputGlobals.getInstance &&
					window.intlTelInputGlobals.getInstance(input)) {
					window.intlTelInputGlobals.getInstance(input).destroy();
				}

				const itl = intlTelInput(input, {
					initialCountry: "ru",
					placeholderNumberType: "MOBILE",
					countrySearch: false,
					separateDialCode: true,
					nationalMode: true,
					strictMode: true,
					autoPlaceholder: "aggressive",
					i18n: {
						selectedCountryAriaLabel: "Выбрано",
						noCountrySelected: "Не выбрано",
						countryListAriaLabel: "Список",
						searchPlaceholder: "Поиск",
						zeroSearchResults: "Не найдено",
						oneSearchResult: "1 результат",
						multipleSearchResults: "${count} результатов",
					},
					loadUtils: () => import("../../../../../assets/js/vendors/utils.js"),
				});

				$input.data('intlTelInput', itl);

				$input.off('input.phone').on('input.phone', function () {
					const phoneValue = itl.getNumber();
					const $hiddenPhone = $(this).closest('.input-group').find('.hidden_phone');

					if ($hiddenPhone.length) {
						$hiddenPhone.val(phoneValue);
					}
				});
			});
		}
	}, 100);
});